<template>
  <div class="bm-insure-list">
    <ul class="insure-list" v-if="list.length>0">
        <li class="list-item" v-for="(item, index) in list" :key="index">
            <div class="name" v-text="getSimpleName(item.productName)"></div>
            <div class="date">
                <span>保障日期：</span>
                <span v-text="formatDate(item.startDate) + '~' +formatDate(item.endDate)"></span>
            </div>
            <div class="state">
                <img class="img" v-show="item.status==0" src="@/assets/insure/guarantee.png">
                <img class="img" v-show="item.status==1" src="@/assets/insure/coming.png">
                <img class="img" v-show="item.status==2" src="@/assets/insure/expired.png">
            </div>
        </li>
    </ul>
    <div v-else class="empty-box">
      <img class="img" src="@/assets/insure/empty.png">
      <div>
        <router-link class="text" :to="{name: 'Home', query: { anchor: 'product' }}" >还没有保单？去看看保障产品吧</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import { getInsureList } from '@/api/insure'
import { getPassport } from '@/libs/passport'

export default {
  name: 'InsureList',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    const self = this
    getPassport('Verify').then((response) => {
      if (response) {
        self.fetchData()
      }
    })

    window.eventBus.$on('WechatAuth', function(data) {
      self.fetchData()
    })
  },
  methods: {
    fetchData() {
      getInsureList().then(response => {
        const result = response.data
        this.list = result.insurances
      })
    },
    formatDate(utcDate) {
      return moment(utcDate).format('YYYY-MM-DD')
    },
    getSimpleName(name) {
      return name.split('（')[0]
    },
    reload() {
      location.reload()
    }
  }
}
</script>

<style lang="stylus">
.bm-insure-list
  .insure-list
    margin 30px
    color #4a4a4a
    .list-item
      background-color #fff
      box-shadow:0px 4px 8px 2px rgba(0,0,0,0.04)
      border-radius:2px;
      filter:blur(0px);
      padding 30px
      margin 30px 0
      height 160px
      position relative
      .name
        font-size 40px; /*px*/
      .date
        font-size 24px; /*px*/
        padding-top 24px
      .state
        float: right
        position: absolute
        right: 8px
        top: 30px
        .img
          width 214px
  .empty-box
    text-align center
    .img
      width 230px
      margin-top 208px
      margin-bottom 60px
    .text
      color #369ad4
      font-size 32px; /*px*/
</style>



// WEBPACK FOOTER //
// src/pages/insure/list.vue